import React from "react";
import { CheckOutlined, ApiOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Tooltip } from "antd";
import { API_ORIGINS, getApiOrigin, setApiOrigin } from "configs/EnvironmentConfig";
import { isSuperAdmin } from "utils/common";

const ORIGIN_LABELS = {
	prod: "Production",
	staging: "Staging",
	local: "Local",
};

export const NavOriginSwitcher = () => {
	if (!isSuperAdmin()) {
		return null;
	}

	const currentOrigin = getApiOrigin();

	const onSelect = (key) => {
		if (key === currentOrigin) return;
		setApiOrigin(key);
		window.location.reload();
	};

	const originOption = (
		<Menu>
			{
				Object.keys(API_ORIGINS).map(key => (
					<Menu.Item
						key={key}
						className={currentOrigin === key ? 'ant-dropdown-menu-item-active' : ''}
						onClick={() => onSelect(key)}
					>
						<span className="d-flex justify-content-between align-items-center">
							<span className="font-weight-normal">{ORIGIN_LABELS[key] ?? key}</span>
							{currentOrigin === key ? <CheckOutlined className="text-success" /> : null}
						</span>
					</Menu.Item>
				))
			}
		</Menu>
	)

	return (
		<Dropdown placement="bottomRight" overlay={originOption} trigger={["click"]}>
			<Menu mode="horizontal">
				<Menu.Item key="origin">
					<Tooltip title={`Data source: ${ORIGIN_LABELS[currentOrigin] ?? currentOrigin}`}>
						<a href="#/" className="text-gray" onClick={e => e.preventDefault()}>
							<ApiOutlined className="nav-icon mr-0" />
						</a>
					</Tooltip>
				</Menu.Item>
			</Menu>
		</Dropdown>
	)
}

export default NavOriginSwitcher;
